import React, { PureComponent } from 'react';

import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Chip from '@material-ui/core/Chip';
import Divider from '@material-ui/core/Divider';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import LinearProgress from '@material-ui/core/LinearProgress';
import MuiAlert from '@material-ui/lab/Alert';
import Paper from '@material-ui/core/Paper';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

import { withStyles } from '@material-ui/core/styles';
import { Component } from 'react';
import { compose } from 'recompose';

//Components
import LoadingBackdrop from '../../public/components/LoadingBackdrop';

//Others libraries
import Chart from "react-google-charts";
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

//Others
const axios = require('axios').default;
const FormData = require('form-data');
const api_base_url = "https://e-learning-be-ybcs6wa7da-as.a.run.app";

const useStyles = theme => ({
    root: {
        margin: 15,
        marginTop: 50
    }
});

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class ProblemReportsChart extends Component {
    constructor() {
        super()
        this.state = {
            testGroup: [],
            isBarChartView: false,
            isLoading: false
        };
    }

    componentDidMount = async () => {
        this.setState({
            isLoading: true
        });

        await this.handleGetAllProblems();

        this.setState({
            isLoading: false
        });
    }

    handleGetAllProblems = async () => {
        try {
            const res = await axios({
                method: 'get',
                url: 'https://chatter-funky-busby.glitch.me/test/problems',
            });

            const problemObj = res.data.problems;
            console.log(problemObj);

            await this.handleRemoveTime(problemObj);
            this.setState({
                problems: problemObj
            });

        } catch (err) {
            console.log(err);
        }
    }

    handleRemoveTime = async (problemsArr) => {
        let groups = [];
        let problemGroupToShowLine = [
            { month: '01', problem: 0 },
            { month: '02', problem: 0 },
            { month: '03', problem: 0 },
            { month: '04', problem: 0 },
            { month: '05', problem: 0 },
            { month: '06', problem: 0 },
            { month: '07', problem: 0 },
            { month: '08', problem: 0 },
            { month: '09', problem: 0 },
            { month: '10', problem: 0 },
            { month: '11', problem: 0 },
            { month: '12', problem: 0 },
        ];
        let problemGroupToShowBar = [
            ['Month', 'Problems']
        ];

        await problemsArr.map(async (problem, index) => {
            const month = new Date(problem.createdAt).getMonth() + 1;
            const monthStr = month >= 10 ? month + '' : '0' + month
            console.log(problem.createdAt);
            console.log(monthStr);
            if (!groups[monthStr]) {
                groups[monthStr] = [];
            }

            let foundIndex = await problemGroupToShowLine.findIndex(x => x.month === monthStr);
            groups[monthStr].push(problem);
            console.log(problemGroupToShowLine);
            problemGroupToShowLine[foundIndex].problem = groups[monthStr].length
        })



        await problemGroupToShowLine.map((problemGroup) => {
            problemGroupToShowBar.push([
                problemGroup.month,
                problemGroup.problem
            ]);
        })

        this.setState({
            problemGroup: groups,
            problemGroupToShowLine: problemGroupToShowLine,
            problemGroupToShowBar: problemGroupToShowBar
        });
    }

    handleToggleBarChartView = () => {
        this.setState({
            isBarChartView: !this.state.isBarChartView
        })
    }

    render() {
        const { classes } = this.props;

        return (
            <Paper style={{ padding: '35px' }} >
                <LoadingBackdrop isLoading={this.state.isLoading} />
                <Grid container>
                    <Grid item align='left' xs={12}>
                        <Typography variant="h5" gutterBottom>
                            Overall problems
                        </Typography>
                    </Grid>
                    <Grid item align='right' xs={12}>
                        <FormControlLabel
                            control={<Switch color="primary" checked={this.state.isBarChartView} onChange={this.handleToggleBarChartView} />}
                            label="Bar chart view"
                        />
                    </Grid>
                    {!this.state.isBarChartView &&
                        <Grid item align='left' xs={12}>
                            <AreaChart
                                width={1000}
                                height={500}
                                data={this.state.problemGroupToShowLine}
                                margin={{
                                    top: 10,
                                    right: 30,
                                    left: 0,
                                    bottom: 0,
                                }}
                            >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="month" />
                                <YAxis />
                                <Tooltip />
                                <Area type="monotone" dataKey="problem" stroke="#8884d8" fill="#8884d8" />
                            </AreaChart>
                        </Grid>
                    }
                    {this.state.isBarChartView &&
                        <Grid item align='left' xs={12}>
                            <Chart
                                width={1000}
                                height={500}
                                chartType="Bar"
                                loader={<div>Loading Chart</div>}
                                data={this.state.problemGroupToShowBar}
                                options={{
                                    // Material design options
                                    chart: {
                                        title: 'Income',
                                        subtitle: 'Overall profit based on number of test assigned.',
                                    },
                                }}
                                margin={{
                                    top: 10,
                                    right: 30,
                                    left: 0,
                                    bottom: 0,
                                }}
                                // For tests
                                rootProps={{ 'data-testid': '2' }}
                            />
                        </Grid>
                    }
                </Grid>
            </Paper >
        )
    }
}
export default compose(
    withStyles(useStyles)
)(ProblemReportsChart);